/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateWorkloadSubjectForm,
  UpdateWorkloadSubjectForm$Outbound,
  UpdateWorkloadSubjectForm$outboundSchema,
} from "../components/updateworkloadsubjectform.js";

export type UpdateWorkloadSubjectSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type UpdateWorkloadSubjectSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateWorkloadSubjectSecurity = {
  option1?: UpdateWorkloadSubjectSecurityOption1 | undefined;
  option2?: UpdateWorkloadSubjectSecurityOption2 | undefined;
};

export type UpdateWorkloadSubjectRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateWorkloadSubjectForm: UpdateWorkloadSubjectForm;
};

/** @internal */
export type UpdateWorkloadSubjectSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateWorkloadSubjectSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateWorkloadSubjectSecurityOption1$Outbound,
  UpdateWorkloadSubjectSecurityOption1
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateWorkloadSubjectSecurityOption1ToJSON(
  updateWorkloadSubjectSecurityOption1: UpdateWorkloadSubjectSecurityOption1,
): string {
  return JSON.stringify(
    UpdateWorkloadSubjectSecurityOption1$outboundSchema.parse(
      updateWorkloadSubjectSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateWorkloadSubjectSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateWorkloadSubjectSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateWorkloadSubjectSecurityOption2$Outbound,
  UpdateWorkloadSubjectSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateWorkloadSubjectSecurityOption2ToJSON(
  updateWorkloadSubjectSecurityOption2: UpdateWorkloadSubjectSecurityOption2,
): string {
  return JSON.stringify(
    UpdateWorkloadSubjectSecurityOption2$outboundSchema.parse(
      updateWorkloadSubjectSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateWorkloadSubjectSecurity$Outbound = {
  Option1?: UpdateWorkloadSubjectSecurityOption1$Outbound | undefined;
  Option2?: UpdateWorkloadSubjectSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateWorkloadSubjectSecurity$outboundSchema: z.ZodMiniType<
  UpdateWorkloadSubjectSecurity$Outbound,
  UpdateWorkloadSubjectSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateWorkloadSubjectSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateWorkloadSubjectSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateWorkloadSubjectSecurityToJSON(
  updateWorkloadSubjectSecurity: UpdateWorkloadSubjectSecurity,
): string {
  return JSON.stringify(
    UpdateWorkloadSubjectSecurity$outboundSchema.parse(
      updateWorkloadSubjectSecurity,
    ),
  );
}

/** @internal */
export type UpdateWorkloadSubjectRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateWorkloadSubjectForm: UpdateWorkloadSubjectForm$Outbound;
};

/** @internal */
export const UpdateWorkloadSubjectRequest$outboundSchema: z.ZodMiniType<
  UpdateWorkloadSubjectRequest$Outbound,
  UpdateWorkloadSubjectRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateWorkloadSubjectForm: UpdateWorkloadSubjectForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateWorkloadSubjectForm: "UpdateWorkloadSubjectForm",
    });
  }),
);

export function updateWorkloadSubjectRequestToJSON(
  updateWorkloadSubjectRequest: UpdateWorkloadSubjectRequest,
): string {
  return JSON.stringify(
    UpdateWorkloadSubjectRequest$outboundSchema.parse(
      updateWorkloadSubjectRequest,
    ),
  );
}
